// Copyright (c) Docugami, Inc. All rights reserved.

import { UserInfo } from 'components/common/Fonts';
import { backgroundGray, greyText } from 'components/shell/presentation/AppStyles';
import { useAccountView } from 'hooks/AccountView';
import { IExplorerNavigationGroup } from 'hooks/ExplorerNavigationGroups';
import styled from 'styled-components';
import { ExplorerNavigationList } from './ExplorerNavigationList'
import { HeaderContainer } from './NavigationItemGroup';

const PanelContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: ${backgroundGray};
    gap: 3px;
    border-right: 1px solid ${greyText};
`

const PanelScrollContainer = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
    min-height: 170px;
    :hover {
        overflow-y: auto
    }
`

const FooterContainer = styled(HeaderContainer)`
    margin-top: auto;
    margin-bottom: 0;
    cursor: default;
`;

const ExplorerFooterText = styled(UserInfo)`
    font-size: 16px;
`;

interface ExplorerPanelProps {
    groups: IExplorerNavigationGroup[],
    selectedId?: string;
}

export const ExplorerPanel = (props: ExplorerPanelProps): JSX.Element => {
    return (
        <PanelContainer>
            <PanelScrollContainer>
                <ExplorerNavigationList selectedId={props.selectedId} groups={props.groups} />
            </PanelScrollContainer>
            <ExplorerPanelFooter />
        </PanelContainer>
    );
}

const ExplorerPanelFooter = (): JSX.Element | null => {
    const { pagesCount, maxPages } = useAccountView();

    if (pagesCount === undefined || !maxPages) {
        return null;
    }

    return (
        <FooterContainer>
            <ExplorerFooterText data-testid="explorer-footer-page-count">
                <b>{pagesCount}</b> of <b>{maxPages}</b> Pages Consumed
            </ExplorerFooterText>
        </FooterContainer>
    );
}